export function getFullNameWithPrefix(data: { name?: string; lastName?: string }, prefix?: string): string {
  if (!(data.name || data.lastName)) {
    return '';
  }

  return [prefix, data.name, data.lastName].filter(Boolean).join(' ');
}
